var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoutteEauHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "goutte_eau_header",
    "data-name": "goutte eau header",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.71,
    height: 38.291,
    viewBox: "0 0 45.71 38.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 45.71,
    height: 38.291,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_85",
    "data-name": "Groupe 85",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_128",
    "data-name": "Trac\\xE9 128",
    d: "M48.349,37.594c.614,1.82,1.958,8.456,4.942,9.977,3,1.539,4.663-.082,5.032-1.2a3.434,3.434,0,0,0-1.571-3.688,16.465,16.465,0,0,1-8.4-5.086",
    transform: "translate(-12.746 -9.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M32.939,33.853S31.189,13.159,26.2,7.206C21.189,1.3,16.829-.026,13.608,0,10.324,0,3.86,1.175,2.5,7.283,1.1,13.427,6.2,17.872,10.276,18.49c4.039.653,13.732,2.442,22.663,15.364",
    transform: "translate(-0.597 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_130",
    "data-name": "Trac\\xE9 130",
    d: "M47.718,21.386c1.407-1.688,6.931-7.132,6.549-10.806C53.81,6.936,51.2,6.465,49.8,6.788a2.772,2.772,0,0,0-1.261.768,3.962,3.962,0,0,0-.934,3.979,16.94,16.94,0,0,1,.117,9.851",
    transform: "translate(-12.5 -1.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_131",
    "data-name": "Trac\\xE9 131",
    d: "M29.555,45.747c-3.418-2.8-14.453-13.8-21.83-12.974C.41,33.755-.49,39.011.183,41.824a5.57,5.57,0,0,0,1.566,2.521A7.962,7.962,0,0,0,9.76,46.153c3.555-1.135,11.448-2.972,19.794-.406",
    transform: "translate(0 -8.628)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoutteEauHeader);
export default __webpack_public_path__ + "static/media/goutte_eau_header.4c612971670e2aff00cac338265716d8.svg";
export { ForwardRef as ReactComponent };